import FinancesPlansPage from "pages/[company]/finances/plan.page";

export default FinancesPlansPage;
